// extracted by mini-css-extract-plugin
export default {"suggestion":"b3P4OF","focused":"c3P4OF","divider":"d3P4OF"};